import { type FC } from 'react'
import { useTranslation } from '@egw/i18n'
import { WEALTH_ROUTES } from '@egw/constants'
import { Activity } from './index'

export interface SavingsActivityPageProps {
  alias: number
}

export const SavingsActivityPage: FC<SavingsActivityPageProps> = ({ alias }) => {
  const { t } = useTranslation('features-transactions')

  return (
    <Activity
      alias={alias}
      title={t('account_activity.title')}
      backLinkUrl={WEALTH_ROUTES.SAVINGS_ACCOUNT_ACTIVITY.backPath?.replace(':alias', alias.toString()) ?? ''}
    />
  )
}
